import React from 'react';

import {Box} from '@pexip/components';

import styles from './PreflightBox.module.scss';

export const PreflightBox: React.FC<
    React.ComponentProps<typeof Box>
> = props => <Box padding="large" className={styles.wrapper} {...props} />;
